"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _moment = _interopRequireDefault(require("moment"));

var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));

var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));

var _LocalTaxi = _interopRequireDefault(require("@material-ui/icons/LocalTaxi"));

var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));

var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));

var _Item = _interopRequireDefault(require("../components/Item"));

var _Header = _interopRequireDefault(require("../components/Header"));

var _HeroBoard = _interopRequireDefault(require("../components/HeroBoard"));

var _ModalLayout = _interopRequireDefault(require("../components/ModalLayout"));

var View = function View(_ref) {
  var title = _ref.title,
      pickupTime = _ref.pickupTime,
      dropoffTime = _ref.dropoffTime,
      provider = _ref.provider,
      reservationNumber = _ref.reservationNumber,
      phoneNumber = _ref.phoneNumber,
      destination = _ref.destination,
      aside = _ref.aside;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _ref2 = [(0, _moment["default"])(pickupTime), (0, _moment["default"])(dropoffTime)],
      pickupMoment = _ref2[0],
      dropoffMoment = _ref2[1];
  var _ref3 = [pickupMoment.format('MMM DD'), dropoffMoment.format('MMM DD')],
      pickupDate = _ref3[0],
      dropoffDate = _ref3[1];
  var _ref4 = [pickupMoment.format('dddd'), dropoffMoment.format('dddd')],
      pickupDay = _ref4[0],
      dropoffDay = _ref4[1];
  var items = [{
    icon: /*#__PURE__*/_react["default"].createElement(_LocalTaxi["default"], null),
    content: provider
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], null),
    content: "".concat(pickupDate, " - ").concat(dropoffDate)
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], null),
    content: reservationNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Phone["default"], null),
    content: phoneNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_LocationOn["default"], null),
    content: destination ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "whitespace-pre-wrap"
    }, destination) : null,
    valign: 'top'
  }];
  return /*#__PURE__*/_react["default"].createElement(_ModalLayout["default"], {
    aside: aside
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, title), /*#__PURE__*/_react["default"].createElement(_HeroBoard["default"], {
    from: {
      label: t('sifts.modals.rentalcar.pickup'),
      text: pickupDate,
      subText: pickupDay
    },
    to: {
      label: t('sifts.modals.rentalcar.dropoff'),
      text: dropoffDate,
      subText: dropoffDay
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/2"
  }, items.map(function (_ref5, index) {
    var content = _ref5.content,
        props = (0, _objectWithoutProperties2["default"])(_ref5, ["content"]);
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], (0, _extends2["default"])({
      key: index
    }, props), content);
  })));
};

View.displayName = 'CarRental';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=RentalCar.js.map